export const UploadCodeCard = ({ loading, upload, onOpenUpload }) => {
  return (
    <div className="col-12 col-sm-6 col-lg-4 col-xl-3 p-0">
      <div className="row m-0 bg-pink p-4 code-preview h-100">
        <div className="col-12 pb-4">
          <h1 className="m-0 text-center code-display">{upload.code}</h1>
        </div>
        <div className="col-12 pb-3">
          <p className="m-0 text-center">Uploaded: {new Date(upload.createdAt).toLocaleString()}</p>
        </div>
        <div className="col-12 p-0">
          <button className="btn btn-lg bg-beige w-100" type="button" onClick={() => onOpenUpload(upload.code)} disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" aria-hidden="true" />
                Loading Images
              </>
            ) : (
              <>
                Review {upload.imageCount} Images <i className="bi bi-download" />
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

